export var FnoBanEnum;
(function (FnoBanEnum) {
    FnoBanEnum["FU"] = "futures";
    FnoBanEnum["OP"] = "options";
})(FnoBanEnum || (FnoBanEnum = {}));
